import styled from 'styled-components';

export const ShareIconSize : number = 40;

export const ShareContainer = styled.div`
  display : flex;
  flex-direction : row;

  margin : 0;
  padding : 0;

  margin-left : calc(10% - 8px);

  * {
    padding : 8px;
  }

  @media (min-width: 768px) {
    
  }
`;